import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { productionAnalyticsHosts } from "@/constants/nossaData";
import { hasAcceptedAnalyticsCookies } from "@/utils/cookieConsent";

export function useGoogleAnalyticsPageViews() {
  const location = useLocation();

  useEffect(() => {
    const isProductionHost = productionAnalyticsHosts.has(window.location.hostname);
    if (!isProductionHost || !hasAcceptedAnalyticsCookies() || window.NOSSA_GA_ENABLED !== true || typeof window.gtag !== "function") {
      return;
    }

    window.gtag("event", "page_view", {
      page_title: document.title,
      page_location: window.location.href,
      page_path: `${location.pathname}${location.search}`,
    });
  }, [location.pathname, location.search]);
}